import {
  MOBILE_BOTTOM_NAV_API_SUCCESS,
  MOBILE_BOTTOM_NAV_API_ERROR,
  FYND_NAVIGATION_API_SUCCESS,
  FYND_NAVIGATION_API_ERROR,
  FYND_NAVIGATION_API_LOADING
} from '../../constants/constant';

const initialMobileBottomNavState = {
  fallback: true,
  list: [],
  fynd: {
    isLoading: false,
    fyndData: null,
    storeName: null,
    error: null
  }
};

function mobileBottomNavReducer(state = initialMobileBottomNavState, action) {
  switch (action.type) {
    case MOBILE_BOTTOM_NAV_API_SUCCESS:
      return { ...state, ...action.data };
    case MOBILE_BOTTOM_NAV_API_ERROR:
      return { ...state, ...action.data };
    case FYND_NAVIGATION_API_LOADING:
      return {
        ...state,
        fynd: { ...state.fynd, ...action.data }
      };
    case FYND_NAVIGATION_API_SUCCESS:
      return {
        ...state,
        fynd: { ...state.fynd, ...action.data }
      };
    case FYND_NAVIGATION_API_ERROR:
      return {
        ...state,
        fynd: { ...state.fynd, ...action.data }
      };
    default:
      return state;
  }
}

export default mobileBottomNavReducer;
